import React, {
  useState,
  useMemo,
  useRef,
  useCallback,
  useEffect,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
// import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import CompanyDetailsModal from "./CompanyDetailsModal";
import UpdateCompanyDetailsModal from "./UpdateCompanyDetailsModal";
import { sweetAlert } from "../Common/Utills/Utills";

const CompanyDetails = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [rmvBtn, setRmvBtn] = useState(false);
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [selectedRowsData, setselectedRowsData] = useState({});
  const [rowAddData, setRowAddData] = useState({
    company_name: "",
    type: "",
    location: "",
  });
  const formRef = useRef(null);
  // console.log("rowData", rowAddData)

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const updateHandleChange = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setselectedRowsData(() => {
        return {
          ...selectedRowsData,
          [name]: value,
        };
      });
    } else {
      console.error("Event or event.target is undefined");
    }
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { company_name, type, location } = rowAddData;

    let BASE_URL = SERVER_URL + `/api/company/company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_name,
        type,
        location,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getData = async () => {
    let BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setRowData(result.data);
      // Check if gridRef is defined and has the api property before using it
      if (gridRef.current && gridRef.current.api) {
        gridRef.current.api.hideOverlay();
      }
    } else {
      setRowData([]);
    }
  };

  let check = true;
  const [loadingOverlayVisible, setLoadingOverlayVisible] = useState(false);
  useEffect(() => {
    if (check) {
      if (loadingOverlayVisible) {
        if (gridRef.current && gridRef.current.api) {
          gridRef.current.api.showLoadingOverlay();
        }
      }

      getData();
      setLoadingOverlayVisible(true);
    }
    check = false;
  }, []);

  // const addData = (newData) => {
  //   console.log("Adding data:", newData);
  //   setRowData((prevData) => [...prevData, newData]);
  // };

  const onCellValueChanged = (params) => {
    const updatedData = params.data;
    updateData(updatedData);
    // setRowData((prevData) =>
    //   prevData.map((row) => (row === params.data ? updatedData : row))
    // );
    // console.log("Updated data:", updatedData);
  };

  const onSelectionChanged = useCallback((event) => {
    const selectedNodes = event.api.getSelectedNodes();
    if (selectedNodes?.length > 1) {
      setRmvBtn(true);
    }
    if (selectedNodes?.length < 2) {
      setRmvBtn(false);
    }
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedRows(selectedData);
    // window.alert("selection changed, " + rowCount + " rows selected");
  }, []);

  const deleteRow = async (id) => {
    // setRowData((prevData) => prevData.filter((row) => row !== rowData));
    const message = "Do you want to delete this company name!";

    const result = await sweetAlert(message);

    if (!result.isConfirmed) {
      return;
    }

    let BASE_URL = SERVER_URL + `/api/company/company-details/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const addDataToModal = async (rowData) => {
    setselectedRowsData(rowData);
  };
  const updateData = async (rowData) => {
    const { id, company_name, type, location } = rowData;
    let BASE_URL = SERVER_URL + `/api/company/company-details/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        company_name,
        type,
        location,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
      // getData();
    } else {
      toast.error(response.message);
      // getData();
    }
  };
  const [colDefs, setColDefs] = useState([
    {
      headerName: "S. No",
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 150,
      // headerCheckboxSelection: true,
      // checkboxSelection: true,
    },
    {
      headerName: "Company Name",
      field: "company_name",
      editable: true,
      minWidth: 205,
    },
    {
      headerName: "Type",
      field: "type",
      editable: true,
      minWidth: 205,
    },
    {
      headerName: "Location",
      field: "location",
      editable: true,
      minWidth: 205,
    },
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <>
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => deleteRow(params.data.id)}
          >
            <i className="mdi mdi-delete" />
          </button>{" "}
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={() => addDataToModal(params.data)}
            data-toggle="modal"
            data-target="#editModal"
          >
            <i className="mdi mdi-note-edit-outline" />
          </button>
        </>
      ),
      minWidth: 205,
    },
  ]);

  const sortingOrder = useMemo(() => {
    return ["desc", "asc", null];
  }, []);
  const defaultColDef = useMemo(() => ({
    filter: true,
    flex: 1,
    editable: true,
    headerPosition: "sticky",
  }));
  const gridOptions = useMemo(
    () => ({
      rowSelection: "multiple",
      suppressRowClickSelection: true,
      suppressCellSelection: true,
    }),
    []
  );
  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  const handleRefreshClick = () => {
    gridRef.current.api.showLoadingOverlay();
    getData();
  };

  const onGridReady = useCallback((params) => {
    params.api.showLoadingOverlay();
  });
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            Company Table &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleRefreshClick}
              >
                Refresh{" "}
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
              </button>
            </span>
          </div>
          <div className="table_btn">
            <div className="mb-3">
              <button
                data-toggle="modal"
                data-target="#exampleModal"
                className="btn btn-outline-primary"
              >
                <span className="mr-1">
                  <i className="mdi mdi-briefcase-upload" />
                </span>
                Add Company
              </button>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <button
                onClick={() => onBtnExport()}
                className="btn btn-outline-excel mr-1 "
              >
                <span className="mr-1">
                  <i className="mdi mdi-file-export"></i>
                </span>
                Export to Excel
              </button>
            </div>
          </div>
          <div>
            <div
              className="ag-theme-quartz"
              style={{ width: "100%", height: 550 }}
            >
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                // domLayout="autoHeight"
                headerHeight={40}
                rowHeight={50}
                sortingOrder={sortingOrder}
                enableCellTextSelection={true}
                // gridOptions={gridOptions}
                rowSelection={"multiple"} // For row selection
                suppressRowClickSelection={true} // For row selection
                suppressCellSelection={true} // For row selection
                onGridReady={onGridReady}
                overlayLoadingTemplate={
                  '<span className="ag-overlay-loading-center">Please wait while your records are loading...</span>'
                }
                onCellValueChanged={onCellValueChanged}
                onSelectionChanged={onSelectionChanged}
              />
            </div>
          </div>

          <CompanyDetailsModal
            handleChange={handleChange}
            //   setimgfile={setimgfile}
            handleAddDataSubmit={handleAddDataSubmit}
            formRef={formRef}
            setRowAddData={setRowAddData}
            rowAddData={rowAddData}
          />
          <UpdateCompanyDetailsModal
            selectedRowsData={selectedRowsData}
            updateHandleChange={updateHandleChange}
            getData={getData}
            setRowAddData={setRowAddData}
            rowAddData={rowAddData}
          />
        </div>
      </div>
    </>
  );
};

export default CompanyDetails;
